import { AssetManagementIntegrationRunStatus, AssetManagementIntegrationStatus, IntegrationsStatusDocument } from "~/graphql/generated/graphql";
import { useApolloClient } from "@vue/apollo-composable";

export const useSideMenuWarnings = async () => {
  const { resolveClient } = useApolloClient();
  const client = resolveClient();

  const status = await client.query({ query: IntegrationsStatusDocument });

  const failingIntegrations =
    status.data.integrations?.filter(
      (integration) =>
        integration.status != AssetManagementIntegrationStatus.Offline && integration.latestRun?.status === AssetManagementIntegrationRunStatus.Failed
    ) ?? [];

  const integrationWarningMessage =
    failingIntegrations.length > 0
      ? failingIntegrations.map((i) => i.name).join(", ")
      : undefined;

  const warnings = [{ menuItem: MenuItemType.INTEGRATION_HUB, count: failingIntegrations.length, message: integrationWarningMessage }];

  return { warnings };
};
